import styled from "styled-components";

const StepInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export default StepInfo